<div class="pupil-mobile-edit-profile-menu">
  <button (click)="cancel($event)" class="pupil-mobile-edit-profile-menu-cancel-btn">Отмена</button>
  <button (click)="save($event)" class="pupil-mobile-edit-profile-menu-save-btn">Сохранить</button>
</div>
